<mat-form-field [style]="Control.Style" appearance="outline">
    <mat-label>{{Control?.DisplayName ||"" | translate}}</mat-label>
    <input matInput [hidden]="!FormControl.value" [formControl]="FormControl" [id]="'input_'+Control.Name" type="color"
        #InputColor />
    <!-- ignore this input  -->
    <input matInput type="text" [hidden]="true" value="palceholder" *ngIf="!(FormControl).value">
    <span (click)="setColor(FormControl)" *ngIf="!(FormControl).value" class="select-color">Select color</span>
    <span matSuffix class="suffix-group">
        <span class="remove-color" [style.position]="'relative'" (click)="RemoveColor($event,FormControl)">
            <mat-icon>delete</mat-icon>
        </span>
        <validation-error-tool-tip [FormControl]="FormControl" [Control]="Control">
        </validation-error-tool-tip>
    </span>
</mat-form-field>